const actions = {
  ADD_JD_BEGIN: 'ADD_JD_BEGIN',
  ADD_JD_SUCCESS: 'ADD_JD_SUCCESS',
  ADD_JD_ERR: 'ADD_JD_ERR',

  READ_JD_BEGIN: 'READ_JD_BEGIN',
  READ_JD_SUCCESS: 'READ_JD_SUCCESS',
  READ_JD_ERR: 'READ_JD_ERR',

  DELETE_JD_BEGIN: 'DELETE_JD_BEGIN',
  DELETE_JD_SUCCESS: 'DELETE_JD_SUCCESS',
  DELETE_JD_ERR: 'DELETE_JD_ERR',

  UPDATE_JD_BEGIN: 'UPDATE_JD_BEGIN',
  UPDATE_JD_SUCCESS: 'UPDATE_JD_SUCCESS',
  UPDATE_JD_ERR: 'UPDATE_JD_ERR',

  AddJDBegin: () => {
    return {
      type: actions.ADD_JD_BEGIN,
    };
  },

  AddJDSuccess: (data) => {
    return {
      type: actions.ADD_JD_SUCCESS,
      data,
    };
  },

  AddJDErr: (err) => {
    return {
      type: actions.ADD_JD_ERR,
      err,
    };
  },

  ReadJDBegin: () => {
    return {
      type: actions.READ_JD_BEGIN,
    };
  },

  ReadJDSuccess: (data) => {
    return {
      type: actions.READ_JD_SUCCESS,
      data,
    };
  },

  ReadJDErr: (err) => {
    return {
      type: actions.READ_JD_ERR,
      err,
    };
  },

  UpdateJDBegin: () => {
    return {
      type: actions.UPDATE_JD_BEGIN,
    };
  },

  UpdateJDSuccess: (data) => {
    return {
      type: actions.UPDATE_JD_SUCCESS,
      data,
    };
  },

  UpdateJDErr: (err) => {
    return {
      type: actions.UPDATE_JD_ERR,
      err,
    };
  },

  DeleteJDBegin: () => {
    return {
      type: actions.DELETE_JD_BEGIN,
    };
  },

  DeleteJDSuccess: (data) => {
    return {
      type: actions.DELETE_JD_SUCCESS,
      data,
    };
  },

  DeleteJDErr: (err) => {
    return {
      type: actions.DELETE_JD_ERR,
      err,
    };
  },
};

export default actions;
